import { useCallback, useMemo } from "react";
import { useGetProfileQuery } from "../service/auth/api";
import { PermissionItem } from "../types/permission.types";

export type PermissionAction = "isView" | "isAdd" | "isEdit" | "isDelete";

export const usePermission = () => {
    const { data: profileData, isLoading } = useGetProfileQuery({});

    const permissions = useMemo(() => profileData?.data?.permission?.permission || [], [profileData]);

    const hasPermission = useCallback((moduleLabel: string, action: PermissionAction = "isView"): boolean => {
        if (isLoading || !profileData) return false;

        // Skip check for Admin (role: 1)
        if (profileData?.data?.role === 1) return true;

        const modulePermission = permissions.find(
            (p: PermissionItem) => p.label.toLowerCase() === moduleLabel.toLowerCase()
        );

        if (!modulePermission) return false;

        return !!modulePermission[action];
    }, [isLoading, profileData, permissions]);

    const getModulePermission = useCallback((moduleLabel: string): PermissionItem | undefined => {
        if (profileData?.data?.role === 1) {
            return {
                label: moduleLabel,
                isView: true,
                isAdd: true,
                isEdit: true,
                isDelete: true,
                sideBarId: 0,
                _id: "admin-perm"
            } as PermissionItem;
        }

        return permissions.find(
            (p: PermissionItem) => p.label.toLowerCase() === moduleLabel.toLowerCase()
        );
    }, [permissions, profileData]);

    return {
        hasPermission,
        getModulePermission,
        isLoading,
        permissions,
    };
};
